import React from 'react';
import PropTypes from 'prop-types';

import Popup from '../../Popup';
import links from '../../../../config/links';
import styles from './usapPopup.scss';

const USAPApplicationPopUp = (props) => {
    const { onConfirmClick, onCloseClick } = props;

    return (
        <Popup
            className={`popup-md`}
            popUpClassName={`${styles.USAPApplicationPopUp}`}
            popUpContentWrapperClassName={`overflow-unset`}
            onCloseClick={onCloseClick}
            config={{
                noPadding: false,
                fullScreen: false,
                topGradient: true,
                showCloseIcon: false,
                scrollable: true,
                style: {
                    height: 680,
                },
            }}
        >
            <div className="w-100">
                <h5 className={styles.title} data-testid="usap-application-popup.title">
                    Thank you for considering USA Pickleball (USAP) for sanctioning your tournament.
                </h5>
                <h4 className={styles.subTitle}>
                    What are the benefits of USAP Sanctioning?
                </h4>
                <ul className={styles.text}>
                    <li> Listing on the USA Pickleball event calendar </li>
                    <li> Comprehensive insurance for players, staff, volunteers and referees </li>
                    <li> Access to the Tournament Director Handbook </li>
                    <li> Referee support </li>
                </ul>
                <h4 className={styles.subTitle}>
                    Sanctioning Process
                </h4>
                <p className={styles.text}>
                    By selecting continue below, you are requesting USAP event sanctioning and will be prompted to select your preferred event sanctioning type
                    in the drop down menu provided.
                </p>
                <ul className={styles.text}>
                    <li> <b>Medal-Match Plus (MMP) Sanctioning</b> - allows a modified referee requirement. </li>
                    <li> <b>Standard Sanctioning</b> - every match is required to have a referee. </li>
                    <li> <b>No-Referee Sanctioning</b> - available for less than 300 players, requires an on-site USAP certified referee. </li>
                </ul>
                <p className={styles.text}>
                    Once your event is created, follow the prompts to submit a sanctioning application to USAP for approval.
                    Your event will display a &lsquo;USAP Sanctioning Pending&rsquo; logo, and all registering players must have an active USAP
                    Player Membership ID.
                </p>
                <p className={styles.text}>
                    To learn more about USAP Sanctioning, please <a href={links.usapArticle} target="_blank" rel="noopener noreferrer">click here.</a>
                </p>
            </div>
            <br />
            <div className="row">
                <div className="col-12 col-md-6 mb16">
                    <button
                        onClick={onCloseClick}
                        type="button"
                        className="btn btn-default btn-xl text-uppercase btn-block"
                        data-testid="usap-application-popup.cancel-btn"
                    >
                        No, Thanks
                    </button>
                </div>
                <div className="col-12 col-md-6">
                    <button
                        onClick={onConfirmClick}
                        type="submit"
                        className="btn btn-primary btn-xl text-uppercase btn-block"
                        data-testid="usap-application-popup.continue-btn"
                    >
                        Continue
                    </button>
                </div>
            </div>
        </Popup>
    );
};

USAPApplicationPopUp.propTypes = {
    onConfirmClick: PropTypes.func,
    onCloseClick: PropTypes.func,
};

USAPApplicationPopUp.defaultProps = {
    onConfirmClick: () => {},
    onCloseClick: () => {},
};

export default USAPApplicationPopUp;
